module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-schedule-times"
  }, [_c('div', {
    staticClass: "ds-time-row"
  }, [_c('div', {
    staticClass: "ds-time-cell"
  }, [_c('v-checkbox', {
    ref: "allDayCheckbox",
    staticClass: "ma-2",
    attrs: {
      "hide-details": "",
      "label": _vm.labels.all,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.allDay),
      callback: function($$v) {
        _vm.allDay = $$v
      },
      expression: "allDay"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ds-time-cell"
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "type": "number",
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.triggerChange
    },
    model: {
      value: (_vm.schedule.duration),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "duration", _vm._n($$v))
      },
      expression: "schedule.duration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ds-time-cell"
  }, [_c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "items": _vm.durationOptions,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.triggerChange
    },
    model: {
      value: (_vm.schedule.durationUnit),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "durationUnit", $$v)
      },
      expression: "schedule.durationUnit"
    }
  })], 1)]), _vm._v(" "), (!_vm.allDay) ? _c('div', _vm._l((_vm.schedule.times), function(time, index) {
    return _c('div', {
      staticClass: "ds-time-row"
    }, [_c('div', {
      staticClass: "ds-time-cell"
    }), _vm._v(" "), _c('ds-schedule-time', {
      key: index,
      staticClass: "ds-time-cell double",
      attrs: {
        "index": index,
        "show-add": _vm.isLastTime(index),
        "show-remove": _vm.hasTimes,
        "value": _vm.schedule.times[index],
        "read-only": _vm.readOnly
      },
      on: {
        "add": _vm.addTime,
        "remove": _vm.removeTime,
        "change": _vm.changeTime
      }
    })], 1)
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-746db5d7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleTimes.vue
// module id = 419
// module chunks = 1